import * as React from "react";

function SvgIcInterior(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M15.4787 5.7761C15.9319 4.11453 17.6878 3.17477 19.3217 3.7194L20.316 4.05083C20.7994 4.21196 21.0843 4.7108 20.9775 5.20904L17.9775 19.209C17.8787 19.6701 17.4713 19.9995 16.9997 19.9995H4.99974C4.5109 19.9995 4.09371 19.6461 4.01335 19.1639L3.72791 17.4513C3.26772 14.6901 5.71307 12.3224 8.45795 12.8714L13.2806 13.8359L15.4787 5.7761ZM18.6892 5.61676C18.1446 5.43522 17.5593 5.74847 17.4082 6.30233L14.9645 15.2626C14.8262 15.7697 14.319 16.0832 13.8036 15.9801L8.06572 14.8325C6.69328 14.558 5.4706 15.7419 5.7007 17.1225L5.84687 17.9995H16.1913L18.8344 5.66516L18.6892 5.61676Z" fill="currentColor"/>
    </svg>
  );
}

export default SvgIcInterior;
